import { createMiddlewareFromEventsMap } from '@noths/polaris-client-next-redux';

import { GAEventsMap as favouritesGAEventsMap } from 'src/components/organisms/Favourites/tracking/eventsMap';
import { GAEventsMap as filterGAEventsMap } from 'src/components/organisms/Filter/tracking/eventsMap';
import { GAEventsMap as productGAEventsMap } from 'src/components/organisms/ProductList/tracking/eventsMap';
import { ReduxApplicationState } from './combinedReducer';
import { GAEventsMap as productsGAEventsMap } from './products/tracking/eventsMap';

export const eventsMap = {
  ...favouritesGAEventsMap,
  ...filterGAEventsMap,
  ...productsGAEventsMap,
  ...productGAEventsMap,
};

export const GAMiddleware = createMiddlewareFromEventsMap<ReduxApplicationState>(eventsMap);
